import { render, staticRenderFns } from "./ClientDialogGD.vue?vue&type=template&id=de4175d8"
import script from "./ClientDialogGD.vue?vue&type=script&lang=js"
export * from "./ClientDialogGD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports